<template>
  <div class="auth-form">
    <img
      class="mt-3 mb-2"
      :src="asset('imgs/zuulOS.png')"
      alt="Zuul Logo"
      width="100"
      height="23"
    />
    <hr />
    <b-form
      @submit.prevent="onRecoverPassword"
      @keyup.enter="onRecoverPassword"
    >
      <h1 class="mt-2 mb-4">Forgot password?</h1>
      <error-alert :errors="errors" class="mb-4" />
      <div v-if="success">
        <p class="success-text">
          A password reset email has been sent. Please check your inbox.
        </p>
      </div>
      <div v-else>
        <p>
          Enter the email address you used to register and check your inbox for
          password reset instructions.
        </p>
        <b-form-input
          v-model="email"
          type="email"
          required
          class="base-input mb-3"
          placeholder="Email address"
          autofocus
        />
        <b-button variant="primary" type="submit" class="w-100">
          <template v-if="loading">
            <button-loader />
          </template>
          <template v-else>Send instructions</template>
        </b-button>
      </div>
      <p class="mt-2 mb-0">
        Already have an account? <router-link to="/login">Sign in.</router-link>
      </p>
    </b-form>
  </div>
</template>

<script>
import ButtonLoader from '../../components/ButtonLoader';
import SessionAPI from '../../services/SessionAPI';

export default {
  name: 'ForgotPasswordPage',
  components: {
    ButtonLoader,
  },
  data() {
    return {
      success: false,
      loading: false,
      email: null,
      errors: {},
    };
  },
  methods: {
    onRecoverPassword() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      SessionAPI.recoverPassword(this.email)
        .then(() => {
          this.loading = false;
          this.success = true;
          this.errors = {};
          this.email = null;
        })
        .catch((error) => {
          this.loading = false;
          this.success = false;

          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>
